import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Grid } from "@mui/material";
import { GetRecoilApprovedList, SetRecoilApprovedList } from "../../store/customerApprovedAtom";

function CustomerApproveScroll({ onSelection, viewItemDetails }) {
  const { customer_id } = useParams();
  const customerApprovedData = GetRecoilApprovedList();
  const setApprovedList = SetRecoilApprovedList();

  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    if (customerApprovedData?.customer_info) {
      const mapped = customerApprovedData.customer_info
        .map((ele) => ({ ...ele, checked: false }))
        .reverse();
      setTableData(mapped);
    }
  }, [customerApprovedData?.customer_info]);

  const handleCheckboxChange = (e, index) => {
    const updated = [...tableData];
    updated[index] = { ...updated[index], checked: e.target.checked };
    setTableData(updated);
    onSelection(updated);
  };

  const statusBadge = (statusName, statusId) => {
    const styles = {
      1: "bg-emerald-100 text-emerald-800 border-emerald-200",
      2: "bg-rose-100 text-rose-800 border-rose-200",
      3: "bg-amber-100 text-amber-800 border-amber-200",
      4: "bg-blue-100 text-blue-800 border-blue-200",
      5: "bg-purple-100 text-purple-800 border-purple-200",
      6: "bg-gray-100 text-gray-700 border-gray-200",
      7: "bg-indigo-100 text-indigo-800 border-indigo-200",
      8: "bg-orange-100 text-orange-800 border-orange-200",
    };

    return (
      <span
        className={`inline-flex px-2.5 py-1 rounded-full text-xs font-medium border ${
          styles[statusId] || "bg-gray-100 text-gray-700 border-gray-200"
        }`}
      >
        {statusName || "Unknown"}
      </span>
    );
  };

  return (
    <div className="h-[calc(100vh-140px)] bg-white rounded-xl border shadow-sm overflow-hidden flex flex-col">
      {/* Header */}
      <div className="bg-gray-50 border-b px-4 py-3">
        <h3 className="text-sm font-semibold text-gray-700">
          Pending Approvals ({tableData.length})
        </h3>
      </div>

      {/* Scrollable List */}
      <div className="flex-1 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 hover:scrollbar-thumb-gray-400">
        {tableData.length === 0 ? (
          <div className="h-full flex items-center justify-center text-gray-500 text-sm">
            No pending customer approvals
          </div>
        ) : (
          tableData.map((corp, index) => {
            const isActive = Number(customer_id) === corp?.Customer_Id;

            return (
              <div
                key={corp.Customer_Id || index}
                className={`
                  group border-b last:border-b-0
                  transition-colors duration-150
                  hover:bg-blue-50/60
                  ${isActive ? "bg-blue-50 border-l-4 border-l-blue-500" : ""}
                `}
              >
                <div className="px-4 py-3 flex items-center gap-3 cursor-pointer" onClick={() => viewItemDetails(corp?.Customer_Id)}>
                  {/* Checkbox - optional / can be re-enabled later for bulk actions */}
                  {/* <div className="flex-shrink-0">
                    <input
                      type="checkbox"
                      checked={corp.checked || false}
                      onChange={(e) => handleCheckboxChange(e, index)}
                      onClick={(e) => e.stopPropagation()}
                      className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                    />
                  </div> */}

                  {/* Main content */}
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between">
                      <p className="text-sm font-semibold text-gray-900 truncate">
                        {corp?.Corporate_Name || "Unnamed Company"}
                      </p>
                    </div>

                    <div className="mt-1 flex flex-col gap-0.5 text-xs text-gray-600">
                      <span className="truncate">{corp?.Customer_Email_Address || "—"}</span>
                      <span>{corp?.Customer_Mobile_No || "—"}</span>
                    </div>

                    <div className="mt-2">
                      {statusBadge(corp?.Customer_Approve_Status_Name, corp?.Customer_Approve_Status_Id)}
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>

      {/* Optional footer - can show count or actions */}
      {tableData.length > 0 && (
        <div className="px-4 py-2.5 bg-gray-50 border-t text-xs text-gray-500">
          Showing {tableData.length} {tableData.length === 1 ? "request" : "requests"}
        </div>
      )}
    </div>
  );
}

export default CustomerApproveScroll;